import { whiteColor, shadowColor, lightgray } from 'theme/color';

export const statusCard = {
  // height: "187px",
  background: '#FFFFFF',
  border: '0.5px solid #E4E4E4',
  // boxShadow: `0px 1px 8px ${shadowColor}`,
  // border:"1px solid #E4E4E4",
  borderRadius: '5px',
  marginBottom: '30px',
  marginTop: '30px',
};

export const moreInfoContainer = {
  marginTop: '20px',
  padding: '15px 14px',
  borderRadius: '8px',
  background: lightgray,
};
